import { Component, Input, OnInit } from '@angular/core';
import { deudaSbifLeasing } from 'src/app/models/utils/utils.model';
import { IGlobalDocumentos, IDeudaSistemaFinancieroReporteModel, IItem } from 'src/app/shared/services/sbif-leasing.service';
import { environment as env } from 'src/environments/environment';

@Component({
  selector: 'app-deuda-leasing-sbif-viewer',
  templateUrl: './deuda-leasing-sbif-viewer.component.html',
  styleUrls: ['./deuda-leasing-sbif-viewer.component.scss']
})
export class DeudaLeasingSbifViewerComponent implements OnInit {
  @Input() content: any | null = null;
  @Input() typeTX: boolean = false; 
  @Input() showHeader: boolean = true;
  public dataSource: any[] = [];
  public headRow: any = [
    'periodo',
    'dirvigente', 
    'dirmorosa', 
    'dirvencida', 
    'diracreedor', 
    'dirhipotecaria', 
    'dirinversion', 
    'diroperacionpacto', 
    'dircomercial', 
    'credcontingente', 
    'monexvigente',
    'monexvencida', 
    'indirectavig', 
    'indirectaven', 
    'castigadadirecta', 
    'castigadaindirecta', 
    'leasingvig', 
    'leasingmor', 
    'dirven180mayor3year', 
    'lineacredito', 
  ];
  public headNames: any = deudaSbifLeasing;
  public rut: string = '';
  public today: string = '';
  public displayedColumns: string[] = [];

  constructor() { }

  ngOnInit(): void {
    this.showDetails();
    this.setToday();
    this.setRut();
  }

  setRut() {
    if(this.typeTX) {
      this.rut = this.content.DeudaSistemaFinancieroReporte?.DatosBasicosSolicitud?.Rut + '-' + this.content.DeudaSistemaFinancieroReporte?.DatosBasicosSolicitud?.DV;
    } else {
      this.rut = this.content?.Documentos?.SbifOnline?.DatosBasicosSolicitud?.Rut + '-' + this.content?.Documentos?.SbifOnline?.DatosBasicosSolicitud?.DV;
    }
  }

  ngOnChanges(): void {
    this.showDetails();
  }

  showDetails(): void {
    this.dataSource = this.typeTX? 
    this.getResponse(this.content?.DeudaSistemaFinancieroReporte?.Documentos?.SbifOnline?.Reporte?.rowsMeses?.item) || []
    : this.getResponse(this.content?.Documentos?.SbifOnline?.Reporte?.rowsMeses?.item) || [];
    if(this.dataSource.length > 0) {
      this.mapeoMatTable();
    }
  }
  
  generateDisplayedColumns(): void {
    this.displayedColumns = [];
    for(const item in (this.dataSource[0])) {
      this.displayedColumns.push(item);
    }
    this.dataSource.shift();
  }

  mapeoMatTable(): void {
    const array: any[] = [];
    for ( const itemH of this.headRow ) {
      const obj: any = {};
      obj.field = itemH;
      // debe ser un for con index
      for (const itemD of this.dataSource) {
        obj[itemD.periodo] = itemD[itemH];
      }
      array.push(obj);
    }
    if(array && array.length > 0) {
      this.dataSource = array || [];
      this.generateDisplayedColumns();
    }
  }

  getResponse(response: IItem[]): IItem[] {    
    if (response && response.length > 0) {
    return response.map((e: any) => {
      return {
        castigadadirecta: e.castigadadirecta,
        castigadaindirecta: e.castigadaindirecta,
        credcontingente: e.credcontingente,
        diracreedor: [e.dirconsumo, e.diracreedor],
        dircomercial: e.dircomercial,
        dirhipotecaria: e.dirhipotecaria,
        dirinversion: e.dirinversion,
        dirmorosa: e.dirmorosa,
        diroperacionpacto: e.diroperacionpacto,
        dirven180mayor3year: e.dirven180mayor3year,
        dirvencida: e.dirvencida,
        dirvigente: e.dirvigente,
        indirectaven: e.indirectaven,
        indirectavig: e.indirectavig,
        leasingmor: e.leasingmor,
        leasingvig: e.leasingvig,
        lineacredito: e.lineacredito,
        monexvencida: e.monexvencida,
        monexvigente: e.monexvigente,
        periodo: this.formatDate(e.periodo)
      }
    }).sort((a,b)=> new Date(b.periodo).getTime() - new Date(a.periodo).getTime()) || []
  }
  return [];
  }

  formatDate(date: string): string {
    return date.split('-').reverse().join('-');
  }

  putColor(rowId: string, value: any): boolean {
    const idsRevisar = [
      'dirmorosa',
      'dirvencida',
      'indirectaven',
      'castigadadirecta',
      'castigadaindirecta',
      'leasingmor',
      'dirven180mayor3year'
    ];
    if(rowId && idsRevisar.includes(rowId)) {
      return value > 0 ? true : false;
    }
    return false;
  }

  setToday() {
    this.today = `${new Date().getFullYear()}${(new Date().getMonth() + 1 < 10?  '0'+(new Date().getMonth() + 1) : 
      new Date().getMonth() + 1)}${new Date().getDate()}`;        
  }

}
